import { TextItemInterface } from '@/types/newTypes'
import React from 'react'
import { useTheme } from '@/components/ThemeProvider'

const WhatYouGetPaywall = ({ version }: { version?: string }) => {
  const { theme } = useTheme()
  const items: TextItemInterface[] = [
    {
      text: 'Fun swipe-to-clean interface',
    },
    {
      text: 'Smart photo suggestions',
    },
    {
      text: 'Free up storage in minutes',
    },
    {
      text: 'Compress videos',
    },
    {
      text: 'Secret Folder',
    },
    {
      text: 'Charge animations',
    },
    {
      text: 'Widgets',
    },
    {
      text: 'Ad blocker',
    },
  ]
  return !version ? (
    <>
      <section
        className="w-full text-black dark:text-white mx-auto flex flex-col p-4 rounded-4xl my-8 gap-4"
        style={{
          background:
            'linear-gradient(112deg, rgb(92, 115, 255) 13.25%, rgb(56, 78, 212) 47.37%, rgb(31, 49, 155) 88.88%)',
        }}
      >
        <h2 className="text-LXL2 leading-[26px] font-bold text-center">What you get</h2>
        <div className="grid grid-cols-2 gap-4">
          {items.map((item, index) => (
            <div key={index} className="flex items-center gap-2">
              <svg viewBox="0 0 16 16" width="16">
                <use href="/svg/sprite.svg#check-yellow"></use>
              </svg>
              <p className="text-SM font-semibold">{item.text}</p>
            </div>
          ))}
        </div>
      </section>
      <img
        src={`${theme === 'light' ? '/img/cards/light/1.png' : '/img/cards/1.png'}`}
        alt="Money-Back Guarantee"
        className="max-w-standard w-full mb-4 mx-auto"
      />
      <p className="text-center text-SM font-semibold">Money-Back Guarantee</p>
    </>
  ) : (
    <div className="relative">
      <section className="w-full text-white dark:text-white  rounded-4xl mt-6 mb-8   relative before:absolute before:content-[''] before:-left-px before:-right-px before:-top-px before:-bottom-px  before:bg-[#A9B2FF] dark:before:bg-transparent dark:before:bg-borgerLightGradient before:rounded-4xl">
        <div className="dark:bg-[#1A1A1D] bg-black rounded-4xl p-4 flex flex-col gap-4 relative">
          <h2 className="text-LXL2 leading-[26px] font-bold text-center">What you get</h2>
          <div className="grid grid-cols-2 gap-x-4 gap-y-2">
            {items.map((item, index) => (
              <div key={index} className="flex items-center gap-2 min-h-8">
                <svg className="min-w-4 h-auto" width="14" height="13">
                  <use
                    href={`${theme === 'light' ? '/svg/sprite.svg#check-blue-new' : '/svg/sprite.svg#check-yellow-new'}`}
                  ></use>
                </svg>
                <p className="text-SM font-medium dark:text-white text-[#373738]">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <img
        src={`${theme === 'light' ? '/img/cards/1.svg' : '/img/cards/1.svg'}`}
        alt="Money-Back Guarantee"
        className="max-w-standard w-full mb-2 mx-auto"
      />
      <p className="text-center text-logo text-[#373738] dark:text-white">Money-Back Guarantee</p>
      <div className="absolute w-[430px] max-w-[calc(100%+2rem)] z-[-1] left-1/2 -translate-x-1/2 dark:-bottom-20 -bottom-10">
        <img
          className="w-full"
          width={440}
          height={440}
          src={`${theme === 'light' ? '/img/email/circle-light.svg' : '/img/email/circle-2.svg'}`}
          alt="vector"
        />
      </div>
    </div>
  )
}

export default WhatYouGetPaywall
